import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { NumberBadge } from '@/components/ui/Badge/NumberBadge';
import { Skeleton } from '@/components/ui/FeedBack/Skeleton';
import { FlatTabs, FlatTab } from '@/components/ui/Tab/FlatTab';
import { hotlineProDetailTabStyle } from '@/feature/hotline/professional/detail/component/HotlineProDetailTab/style';
import { pagePath } from '@/utils/router/pagePath';
/** 内容詳細 */
export const HOTLINE_PRO_DETAIL_TAB_VALUE_DETAIL = 'detail';
/** チャット */
export const HOTLINE_PRO_DETAIL_TAB_VALUE_NEGOTIATE = 'negotiate';
/**
 * 匿名ホットライン コンサル詳細 タブ
 */
export const HotlineProDetailTab = (props) => {
    const { activeValue, className = '', isSkeleton } = props;
    /** タブの内容 */
    const tabs = [
        {
            labelPc: 'チャット',
            labelSp: 'チャット',
            link: isSkeleton
                ? ''
                : pagePath.hotline.professional.detailNegotiate(props.id),
            value: HOTLINE_PRO_DETAIL_TAB_VALUE_NEGOTIATE,
        },
        {
            labelPc: '相談内容を確認',
            labelSp: '相談内容',
            link: isSkeleton ? '' : pagePath.hotline.professional.detail(props.id),
            value: HOTLINE_PRO_DETAIL_TAB_VALUE_DETAIL,
        },
    ];
    const style = hotlineProDetailTabStyle();
    return (_jsx(FlatTabs, Object.assign({ className: style.base({ class: className }) }, { children: tabs.map((tab) => (_jsx(FlatTab, Object.assign({ activeValue: activeValue, className: style.tab(), disabled: isSkeleton, to: tab.link, value: tab.value }, { children: isSkeleton ? (
            // スケルトン表示
            _jsx(Skeleton, { className: 'w-[80px] h-[24px]' })) : (
            // 通常表示
            _jsxs(_Fragment, { children: [_jsx("span", Object.assign({ className: style.textPc() }, { children: tab.labelPc })), _jsx("span", Object.assign({ className: style.textSp() }, { children: tab.labelSp })), tab.value === HOTLINE_PRO_DETAIL_TAB_VALUE_NEGOTIATE &&
                        !!props.unreadCount && (_jsx(NumberBadge, { className: style.badge(), number: props.unreadCount }))] })) }), tab.value))) })));
};
